/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const CropLightningIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Crop Lightning',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M16 27a10.962 10.962 0 0 1 .416-3H12V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v5H3a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h5v15a1 1 0 0 0 1 1h7.046c-.03-.329-.046-.663-.046-1ZM24 16.416A10.962 10.962 0 0 1 27 16c.337 0 .671.016 1 .046V9a1 1 0 0 0-1-1H14v4h10ZM27 18a9 9 0 1 0 9 9 9 9 0 0 0-9-9Zm4.081 9.748-5.927 6.778a.613.613 0 0 1-1.027-.642l2-4.749-2.827-1.214a1.059 1.059 0 0 1-.379-1.67l5.928-6.777a.613.613 0 0 1 1.026.642l-2 4.749 2.825 1.214a1.058 1.058 0 0 1 .381 1.669Z"
    />
  </svg>`;
};
